interface ISkeletonLoaderProps {
  width: string;
  height: string;
  circle?: boolean;
}

const SkeletonLoader: React.FC<ISkeletonLoaderProps> = ({
  width,
  height,
  circle,
}) => {
  return (
    <>
      <div className="container"></div>
      <style jsx>{`
        .container {
          box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15);
          border-radius: 4px;
          position: relative;
          overflow: hidden;
          width: ${width};
          height: ${height};
          border-radius: ${circle ? `50%` : `none`};
        }

        .container::before {
          content: '';
          display: block;
          position: absolute;
          left: -150px;
          top: 0;
          height: 100%;
          width: 150px;
          background: linear-gradient(
            to right,
            transparent 0%,
            #e8e8e8 50%,
            transparent 100%
          );
          animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }

        @keyframes load {
          from {
            left: -150px;
          }
          to {
            left: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default SkeletonLoader;
